var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomaticBenefitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 60,
    viewBox: "0 0 84 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 60,
    rx: 30,
    fill: "#F7F6F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8783_632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4482 47.0478C59.6203 47.0478 59.7842 46.9739 59.898 46.8448C60.0119 46.7158 60.065 46.5441 60.0436 46.3733L57.6374 27.1233C57.5998 26.8231 57.3446 26.5978 57.042 26.5978H47.417C47.1144 26.5978 46.8592 26.8231 46.8216 27.1233L44.4154 46.3733C44.394 46.5441 44.447 46.7158 44.5609 46.8448C44.6748 46.9739 44.8386 47.0478 45.0107 47.0478H59.4482Z",
    stroke: "#0D4248",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_8783_632",
    maskUnits: "userSpaceOnUse",
    x: 31.7812,
    y: 30.8125,
    width: 15,
    height: 17,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 31.7812,
    y: 30.8125,
    width: 15,
    height: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6042 46.4479H33.7812L36.1875 32.8125H46.6146"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.7812 46.4479L32.5995 46.2394C32.5379 46.5887 32.6339 46.9474 32.8619 47.2192C33.0899 47.491 33.4265 47.6479 33.7812 47.6479V46.4479ZM36.1875 32.8125V31.6125C35.6052 31.6125 35.107 32.0305 35.0058 32.604L36.1875 32.8125ZM42.6042 45.2479H33.7812V47.6479H42.6042V45.2479ZM34.963 46.6565L37.3692 33.021L35.0058 32.604L32.5995 46.2394L34.963 46.6565ZM36.1875 34.0125H46.6146V31.6125H36.1875V34.0125Z",
    fill: "#0D4248",
    mask: "url(#path-3-outside-1_8783_632)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-2_8783_632",
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 36,
    width: 14,
    height: 12,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 21,
    y: 36,
    width: 14,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25 46H23L24.5 38H35"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 46L21.8206 45.7789C21.7548 46.1297 21.8486 46.4917 22.0766 46.7664C22.3046 47.0411 22.643 47.2 23 47.2V46ZM24.5 38V36.8C23.9225 36.8 23.427 37.2113 23.3206 37.7789L24.5 38ZM31.25 44.8H23V47.2H31.25V44.8ZM24.1794 46.2211L25.6794 38.2211L23.3206 37.7789L21.8206 45.7789L24.1794 46.2211ZM24.5 39.2H35V36.8H24.5V39.2Z",
    fill: "#0D4248",
    mask: "url(#path-5-outside-2_8783_632)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3154 24.2402C22.1635 24.3053 22.0452 24.4301 21.9884 24.5853C21.9315 24.7405 21.9412 24.9122 22.0151 25.06L24.4214 29.8725C24.5634 30.1566 24.9024 30.2808 25.1944 30.1557L35.8584 25.5853L37.2343 29.0249C37.3248 29.2513 37.5433 29.4003 37.7871 29.4021C38.0308 29.4038 38.2514 29.2579 38.3452 29.0329L42.3556 19.4079C42.4197 19.2539 42.4169 19.0803 42.3479 18.9285C42.2788 18.7768 42.1497 18.6606 41.9915 18.6079L32.3665 15.3995C32.1449 15.3257 31.9005 15.3872 31.7402 15.5571C31.5799 15.7271 31.5329 15.9747 31.6197 16.1916L33.0064 19.6583L22.3154 24.2402Z",
    stroke: "#0D4248",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.833 29.604L55.4372 44.0415",
    stroke: "#0D4248",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8783_632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 41,
    fill: "white",
    transform: "translate(22 9.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticBenefitIcon);
export default __webpack_public_path__ + "static/media/automatic-benefit-icon.070f031b39a5166ab2be0a32bd0081d3.svg";
export { ForwardRef as ReactComponent };